import React, { useEffect, useState } from "react";
import classes from "./Drawer.module.css";

import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import { unsubscribeApi } from "../http/http";


const Drawer = ({ drawer, setDrawer, setShowDialog }) => {
   const navigate = useNavigate();
  const [msisdn, setMsisdn] = useState('');

  
  useEffect(() => {
    const cookieValue = Cookies.get("user_msisdn");
    if (cookieValue) setMsisdn(cookieValue);
  }, []);

  const handleNavigate = (path) => {
    setDrawer(false);
    navigate(path);
  };

    return (
        <div
            className={`${classes.drawer} ${drawer && classes.show}`}
            onClick={() => setDrawer(false)}
        >
            <div
                className={classes.drawer_container}
                onClick={(e) => e.stopPropagation()}
            >
                <div className={classes.menu_items}>
                    <button className={classes.menu_item}
                        onClick={() => handleNavigate("/")}
                    >
                        Home
                    </button>
                    <div className={classes.divider}></div>

                    <button className={classes.menu_item}
                        onClick={() => handleNavigate("/category/rhymes")}
                    >
                        Categories
                    </button>
                    <div className={classes.divider}></div>


                    {/* <button className={classes.menu_item}
                    // onClick={()=>handleNavigate("/categories/rhymes")}
                    >
                        Terms & Conditions
                    </button> */}
                    {/* <button type="button" className={classes.nav_item_btn}
                        onClick={() => setShowDialog(true)}
                    >
                        Unsubscribe
                    </button> */}

                </div>
            </div>

        </div>
    );
};

export default Drawer;